import { getTaxInvoiceDetails } from '../../../../../../api/order'
import { getTaxInvoicePDF } from '../../../../../../api/pdf'

export default async function generateTaxInvoicePdf(orderId: string) {
  const taxInvoiceDetails = await getTaxInvoiceDetails(orderId)
  return getTaxInvoicePDF(taxInvoiceDetails)
}
